import React from "react";

const CloseIcon = ({ size = 50, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 57 57"
    fill="none"
    {...props}
  >
    <path
      d="M21.2129 35.3564L35.355 21.2143"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35.355 35.356L21.2129 21.2139"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CloseIcon;
